import { render, staticRenderFns } from "./SaidasPrimeiroSemestreProduto.vue?vue&type=template&id=84ee3768&scoped=true"
import script from "./SaidasPrimeiroSemestreProduto.vue?vue&type=script&lang=js"
export * from "./SaidasPrimeiroSemestreProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ee3768",
  null
  
)

export default component.exports